
import { faComment } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";

 
 export const ChatButton = ({handleClick}) => {
    return (
        <div className="button-container">
            <button 
                className={classNames("chat-button","rnd")}
                onClick={handleClick}
            >
                <FontAwesomeIcon icon={faComment} />
            </button>
        </div>
    );
 }